// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"5ce83eb2","455":"83382306","866":"dfa61df2","977":"36ae66c4"}[chunkId] + ".chunk.js";
};